import { render, staticRenderFns } from "./result-print.vue?vue&type=template&id=a9b82642&scoped=true&"
import script from "./result-print.vue?vue&type=script&lang=js&"
export * from "./result-print.vue?vue&type=script&lang=js&"
import style0 from "./result-print.vue?vue&type=style&index=0&id=a9b82642&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b82642",
  null
  
)

export default component.exports